import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import * as actions from '../../../store/actions/index';

class Logout extends Component {

    componentDidMount() {
        this.props.onLogout()
    }


    render () {
        return <Redirect to="/admin" />
    }
}

const mapDispatchTopProps = dispatch => {
    return {
        onLogout: () => dispatch(actions.logout())
    }
}

export default connect(null, mapDispatchTopProps)(Logout);


// WEBPACK FOOTER //
// ./src/containers/Auth/Logout/Logout.js